import React, { Component } from 'react';
import { Row, Col, Card, Container, Form, ButtonGroup, Button } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { Scrollbars } from 'react-custom-scrollbars'
import SelectBoxWithDisabledOption from '../../selectdropdown/SelectBoxWithDisabledOption';
import CardLessDataTable from '../../../../neetjee_guru/components/datatables/CardLessDataTableWithSearch';
import EditQuestionSelectedDetails from './EditQuestionSelectedDetails';
import EditExamMadeEasyModal from './EditExamMadeEasyModal';
import { components } from 'react-select';
import MultiSelect from "react-multi-select-component";
import '../_exam_made_easy.scss';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { Link, withRouter } from 'react-router-dom';
import parse, { domToReact } from 'html-react-parser';
import moment from 'moment';
import { scroller } from "react-scroll";

const GROUPEXAMMADEEASY_PAPER = gql`
  mutation(
    $params:ExamMadeEasyPaper,
    $time_duration:Int,
    $question_count:[SubjectQuestionCount],
    $examPaperId: Int 
    ) {
        createExamMadeEasyPaper(
        params: $params,
        time_duration: $time_duration,
        question_count: $question_count,
        examPaperId: $examPaperId
     ){
         filename
        exam_paper_id
        exam_questions{
            id
            subject
            chapter
            question
            option1
            option2
            option3
            option4
            qtype
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
            chapter_name
        }
     }
  }
`;

const GROUPEXAMMADEEASY_DRAFT_PAPER = gql`
  mutation(
    $params:ExamMadeEasyPaper,
    $time_duration:Int,
    $question_count:[SubjectQuestionCount],
    $examPaperId: Int
    ) {
        examMadeEasyDraftPapers(
        params: $params,
        time_duration: $time_duration,
        question_count: $question_count,
        examPaperId: $examPaperId
     ){
         filename
        exam_paper_id
        exam_questions{
            id
            subject
            chapter
            question
            option1
            option2
            option3
            option4
            qtype
            compquestion
            list1type
            list2type
            mat_question
            answer
            inputquestion
            chapter_name
        }
     }
  }
`;

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: 6,
        width: '3px',
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};
const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};
class EditExamMadeEasy extends Component {
    constructor(props) {
        super(props)

        let clsdata = props.globals.classes.map((item) => {
            if (item.id == "1") {
                return { ...item, active: "outline-secondary active" }
            }
            return { ...item, active: "outline-secondary" }

        })
        this.state = {
            examPaperId: parseInt(props.location.state.examDetails.id),
            exam_name: props.location.state.examDetails.name,
            exam_type: props.location.state.examDetails.exam_type,
            exam_typeValue: "",
            class_id: "",
            classData_s: clsdata,
            classvalue: "",
            generate_type: "2",
            pattern_type: "0",
            jee_pattern_type: "0",
            subjects: [],
            syllabusclass: "1",
            qbQuestionSearchSubject: "0",
            qbsearchsubject: "0",
            qbsearchsubjectvalue: "",
            qbsearchchapter: "0",
            qbsearchchaptervalue: "",
            qbsearchtopic: [],
            qbsearchtopicvalue: [],
            typeOfQuestion: "0",
            typeOfQuestionvalue: "",
            complexity: "0",
            complexityvalue: "",
            subjectOptions: [],
            getChaptersArr: [],
            getTopicsArr: [],
            getTypeOfQuestionsArr: [],
            getComplexityValueArr: [],
            getQuestionBankQuestions: "",
            validateSubject: "",
            validateChapter: "",
            validateTopic: "",
            validateTypeOfQuestion: "",
            validateComplexity: "",
            checkedVall: false,
            activePage: 1,
            totalItemsCount: 0,
            itemsCountPerPage: 10,
            showSpinner: "hide",
            otherexam: "",
            noofsets: "1",
            startdate: "",
            enddate: "",
            currentStep: 1,
            getSectionsArr: [],
            branchSelected: [],
            sectionSelected: [],
            sectionSelectedvalue: [],
            generalQuestionsBotanySelected: [],
            generalQuestionsZoologySelected: [],
            generalQuestionsPhysicsSelected: [],
            generalQuestionsChemistrySelected: [],
            generalQuestionsMathsSelected: [],
            integerQuestionsBotanySelected: [],
            integerQuestionsZoologySelected: [],
            integerQuestionsPhysicsSelected: [],
            integerQuestionsChemistrySelected: [],
            integerQuestionsMathsSelected: [],

            generalQuestionsCount: 0,
            integerQuestionCount: 0,

            modalShow: false,
            submitError1: "",
            paper_generate_type: "",
            subjectWiseSelectedQus: [],
            questionbank_checked: true,
            selectedTopicIdsArr: [],
            timeduration: 90,
            validateEamcetExamType: "",
            examTypeOptions: [],
            owedqfilterclass: "1",
            formErrors: {
                exam_type: "",
                branch: "",
                class: "",
                section: "",
                exam_name: "",
                eamcetExamType: "",
                timeduration: ""
            },
            add3Hours_val: "",
            showQuestionsNotAvailable: "yes",
            isSubmitting: false


        }
    }

    componentDidMount() {
        let examTypeName = "";

        if (this.props.location.state.examDetails.exam_type == "1") {
            examTypeName = "NEET"
        } else if (this.props.location.state.examDetails.exam_type == "2") {
            examTypeName = "JEE"
        } else if (this.props.location.state.examDetails.exam_type == "3") {
            examTypeName = "AP-EAMCET-MPC";
        } else if (this.props.location.state.examDetails.exam_type == "6") {
            examTypeName = "TS-EAMCET-MPC"
        } else if (this.props.location.state.examDetails.exam_type == "7") {
            examTypeName = "AP-EAMCET-BiPC"
        } else if (this.props.location.state.examDetails.exam_type == "8") {
            examTypeName = "TS-EAMCET-BiPC"
        }


        this.setState({
            exam_typeValue: {
                value: this.props.location.state.examDetails.exam_type,
                label: examTypeName
            }, exam_type: this.props.location.state.examDetails.exam_type
        });

        let examsData = this.props.globals.exams.find((a) => a.id == this.state.exam_type);
        let examsubjectData = examsData.exam_subjects;
        let subjects = [];
        let subjectOptionsArr = []
        // newcodeend
        for (let i = 0; i <= examsubjectData.length; i++) {
            let idata = examsubjectData[i];
            console.log("idata", idata);
            if (idata != undefined) {
                let subjectData = this.props.globals.subjects.find((a) => a.id == idata.subject_id);
                // console.log("subjectData", subjectData);
                let chapters = [];
                if (this.state.exam_type == "3" || this.state.exam_type == "6" || this.state.exam_type == "7" || this.state.exam_type == "8") {
                    chapters = subjectData.state_chapters.filter(item1 => parseInt(item1.exam_id) == parseInt(this.state.exam_type)).map((item) => {
                        console.log("subjectDatassss", chapters);
                        const topic = item.state_topics.map((topicData) => {
                            return { ...topicData, checked: false }
                        })

                        const questionbarray = this.props.location.state.examDetails.exam_questions.filter((a) => {
                            if (a.chapter == item.id) {
                                return a;
                            }
                            else if (a.chapter.indexOf(',') > 1) {
                                let arr = a.chapter.split(',');
                                if (arr.indexOf(item.id) == 0) {
                                    return a;
                                }
                            }
                        });

                        if (questionbarray.length > 0) {
                            return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [...questionbarray] }
                        }
                        return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                    })
                } else {
                    chapters = subjectData.chapters.map((item) => {
                        console.log("subjectData", subjectData);
                        const topic = item.topics.map((topicData) => {
                            return { ...topicData, checked: false }
                        })

                        const questionbarray = this.props.location.state.examDetails.exam_questions.filter((a) => {
                            if (a.chapter == item.id) {
                                return a;
                            }
                            else if (a.chapter.indexOf(',') > 1) {
                                let arr = a.chapter.split(',');
                                if (arr.indexOf(item.id) == 0) {
                                    return a;
                                }
                            }
                        });

                        if (questionbarray.length > 0) {
                            return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [...questionbarray] }
                        }
                        return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                    })
                }

                /*let chapters = subjectData.chapters.map((item) => {
                    console.log("subjectData", subjectData);
                    const topic = item.topics.map((topicData) => {
                        return { ...topicData, checked: false }
                    })
 
                    const questionbarray = this.props.location.state.examDetails.exam_questions.filter((a) => {
                       if(a.chapter == item.id){
                           return a;
                       }
                       else if(a.chapter.indexOf(',') > 1){
                           let arr = a.chapter.split(',');
                           if(arr.indexOf(item.id) == 0){
                               return a;
                           }
                       } 
                   });
                   if(questionbarray.length > 0){
                       return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [...questionbarray] }
                   }
                   return { ...item, topics: topic, chapteractive: "d-flex justify-content-between align-items-center", checked: false, checkedall: false, ownedarray: [], questionbarray: [] }
                })*/
                const newObject = {
                    id: subjectData.id,
                    subject: subjectData.subject,
                    chapters: chapters,
                    checked: false,
                    subjectactive: "d-flex justify-content-between align-items-center",
                    qcount: idata.no_of_questions,
                    totError: ""

                }
                const newObj = {
                    value: subjectData.id,
                    label: subjectData.subject,
                }
                subjects.push(newObject);
                subjectOptionsArr.push(newObj);


            }

        }


        let examTypeArr = [];
        this.props.globals.exams.map(item => {
            if (item.id == this.state.exam_type) {
                const newObj1 = {
                    value: item.id,
                    label: item.exam
                }
                examTypeArr.push(newObj1);
            }

        });



        let questionTypeArr = [];
        this.props.globals.questionTypes.map(item => {
            if (this.state.exam_type != "2") {
                if (item.id == 7) {
                    const newObj1 = {
                        value: item.id,
                        label: item.questiontype
                    }
                    questionTypeArr.push(newObj1);
                }
            } else {
                if (item.id == 7 || item.id == 8) {
                    const newObj1 = {
                        value: item.id,
                        label: item.questiontype
                    }
                    questionTypeArr.push(newObj1);
                }
            }


        })
        let complexityArr = [];
        this.props.globals.complexity.map(item => {
            if (item.id != 5) {
                const newObj2 = {
                    value: item.id,
                    label: item.complexity
                }
                complexityArr.push(newObj2);
            }

        })

        let sectionsArr = [];
        for (let i = 0; i <= this.props.globals.globalSections.length; i++) {
            let idata = this.props.globals.globalSections[i];
            if (idata != undefined) {
                if (this.state.exam_type == idata.exam_id) {
                    const newObj = {
                        value: idata.id,
                        label: idata.section_name,
                        branch: idata.branch_id
                    }
                    sectionsArr.push(newObj);
                }
            }
        }



        this.setState({
            subjects: subjects,
            subjectOptions: subjectOptionsArr,
            getTypeOfQuestionsArr: questionTypeArr,
            getComplexityValueArr: complexityArr,
            getSectionsArr: sectionsArr,
            examTypeOptions: examTypeArr
        });
    }
    getChapters = () => {
        console.log("aravind", this.state.subjects)
        let getArray = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                console.log("aravind", idata.id)
                console.log("aravind", this.state.qbsearchsubject)
                if (idata.id == this.state.qbsearchsubject) {
                    let chData = "";
                    if (this.state.owedqfilterclass != "0") {
                        chData = idata.chapters.filter((a) => a.class == this.state.owedqfilterclass);
                    }
                    else {
                        chData = idata.chapters;
                    }
                    chData.map((chmapData) => {
                        const newObj = {
                            value: chmapData.id,
                            label: chmapData.chapter
                        }
                        getArray.push(newObj);
                    })

                }
            }

        }
        this.setState({
            getChaptersArr: getArray
        });

    }
    getTopics = () => {
        let getTopicArr = [];
        for (let i = 0; i <= this.state.subjects.length; i++) {
            let idata = this.state.subjects[i];
            if (idata != undefined) {
                if (idata.id == this.state.qbsearchsubject) {
                    idata.chapters.map((chmapData) => {
                        if (chmapData.id == this.state.qbsearchchapter) {
                            chmapData.topics.map((topicData) => {
                                const newObj = {
                                    value: topicData.id,
                                    label: topicData.topic
                                }
                                getTopicArr.push(newObj);

                            })


                        }

                    })

                }
            }

        }


        this.setState({
            getTopicsArr: getTopicArr

        });

        //return getTopicArr;
    }

    squestioncount = (e, subid) => {

        let arr = this.state.subjects.map(item => {
            console.log(e.target.value, "subjects");
            if (item.id == subid) {
                const re = /^[0-9\b]+$/;
                if (re.test(e.target.value)) {
                    return { ...item, qcount: parseInt(e.target.value), totError: "" };
                } else {
                    return { ...item, qcount: "", totError: "Invalid Input" }
                }
                // const qtype = item.questionTheory.map(qitem => {
                //     if (qitem.id == qtyid) {
                //         const re = /^[0-9\b]+$/;
                //         if (re.test(e.target.value)) {
                //             if (e.target.value > 100) {
                //                 return { ...qitem, percentage: "", totperError: "Total percentage should be 100%" }
                //             }
                //             else {
                //                 return { ...qitem, percentage: e.target.value, totperError: "" }
                //             }
                //         } else {
                //             return { ...qitem, percentage: "", totperError: "Invalid Input" }
                //         }

                //     }
                //     return qitem;
                // })

            }
            return item;
        }

        )
        this.setState({ subjects: arr });
        //this.totalpercentagequestionTheory(arr, subid, qtyid);


    }
    QuestionFunction = (e, questionsdata, type) => {
        console.log("mQuestionFunction", e, questionsdata, type, this.state.subjects);

        let subjectArray = [];




        if (type == "qbank") {
            if (this.state.generate_type == "2") {
                if (e?.target?.checked == true) {
                    console.log("e.target.checked", e.target.id)
                    //validation 
                    if (this.state.qbsearchsubject == "1") {
                        if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
                            if (this.state.integerQuestionsBotanySelected.length > this.state.integerQuestionCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else {
                            if (this.state.generalQuestionsBotanySelected.length > this.state.generalQuestionsCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        }

                    } else if (this.state.qbsearchsubject == "2") {
                        if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
                            if (this.state.integerQuestionsPhysicsSelected.length > this.state.integerQuestionCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else {
                            if (this.state.generalQuestionsPhysicsSelected.length > this.state.generalQuestionsCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        }

                    } else if (this.state.qbsearchsubject == "3") {
                        if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
                            if (this.state.integerQuestionsChemistrySelected.length > this.state.integerQuestionCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else {
                            if (this.state.generalQuestionsChemistrySelected.length > this.state.generalQuestionsCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        }

                    } else if (this.state.qbsearchsubject == "4") {

                        if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
                            if (this.state.integerQuestionsMathsSelected.length > this.state.integerQuestionCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else if (this.state.exam_type == 3 || this.state.exam_type == 6) {
                            if (this.state.generalQuestionsMathsSelected.length > 79) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else {
                            if (this.state.generalQuestionsMathsSelected.length > this.state.generalQuestionsCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        }

                    } else if (this.state.qbsearchsubject == "5") {
                        if (this.state.exam_type == 2 && questionsdata.qtype == "8") {
                            if (this.state.integerQuestionsZoologySelected.length > this.state.integerQuestionCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        } else {
                            if (this.state.generalQuestionsZoologySelected.length > this.state.generalQuestionsCount) {
                                scroller.scrollTo("your_css_class_here", {
                                    duration: 800,
                                    delay: 0,
                                    smooth: "easeInOutQuart",
                                });
                                this.setState({ checked: !this.state.checkedVall });
                                return;
                            }
                        }


                    }
                    //validation
                    if (this.state.qbsearchsubject == "1") {
                        if (questionsdata.qtype == "8") {
                            this.state.integerQuestionsBotanySelected.push(questionsdata);
                        } else {
                            this.state.generalQuestionsBotanySelected.push(questionsdata);
                        }
                    } else if (this.state.qbsearchsubject == "2") {
                        if (questionsdata.qtype == "8") {
                            this.state.integerQuestionsPhysicsSelected.push(questionsdata);
                        } else {
                            this.state.generalQuestionsPhysicsSelected.push(questionsdata);
                        }
                    } else if (this.state.qbsearchsubject == "3") {
                        if (questionsdata.qtype == "8") {
                            this.state.integerQuestionsChemistrySelected.push(questionsdata);
                        } else {
                            this.state.generalQuestionsChemistrySelected.push(questionsdata);
                        }
                    } else if (this.state.qbsearchsubject == "5") {
                        if (questionsdata.qtype == "8") {
                            this.state.integerQuestionsZoologySelected.push(questionsdata);
                        } else {
                            this.state.generalQuestionsZoologySelected.push(questionsdata);
                        }
                    } else if (this.state.qbsearchsubject == "4") {
                        if (questionsdata.qtype == "8") {
                            this.state.integerQuestionsMathsSelected.push(questionsdata);
                        } else {
                            this.state.generalQuestionsMathsSelected.push(questionsdata);
                        }
                    }
                } else {
                    console.log("checjed");


                    if (this.state.qbsearchsubject == "1") {


                        if (questionsdata.qtype == "8") {
                            for (var i in this.state.integerQuestionsBotanySelected) {
                                if (this.state.integerQuestionsBotanySelected[i].id == questionsdata.id) {
                                    this.state.integerQuestionsBotanySelected.splice(i, 1);
                                    this.setState({ integerQuestionsBotanySelected: this.state.integerQuestionsBotanySelected });
                                }

                            }
                        } else {
                            for (var i in this.state.generalQuestionsBotanySelected) {
                                if (this.state.generalQuestionsBotanySelected[i].id == questionsdata.id) {
                                    this.state.generalQuestionsBotanySelected.splice(i, 1);
                                    this.setState({ generalQuestionsBotanySelected: this.state.generalQuestionsBotanySelected });
                                }

                            }
                        }


                    } else if (this.state.qbsearchsubject == "2") {
                        if (questionsdata.qtype == "8") {
                            for (var i in this.state.integerQuestionsPhysicsSelected) {
                                if (this.state.integerQuestionsPhysicsSelected[i].id == questionsdata.id) {
                                    this.state.integerQuestionsPhysicsSelected.splice(i, 1);
                                    this.setState({ integerQuestionsPhysicsSelected: this.state.integerQuestionsPhysicsSelected });
                                }

                            }
                        } else {
                            for (var i in this.state.generalQuestionsPhysicsSelected) {
                                if (this.state.generalQuestionsPhysicsSelected[i].id == questionsdata.id) {
                                    this.state.generalQuestionsPhysicsSelected.splice(i, 1);
                                    this.setState({ generalQuestionsPhysicsSelected: this.state.generalQuestionsPhysicsSelected });
                                }

                            }
                        }
                    } else if (this.state.qbsearchsubject == "3") {
                        if (questionsdata.qtype == "8") {
                            for (var i in this.state.integerQuestionsChemistrySelected) {
                                if (this.state.integerQuestionsChemistrySelected[i].id == questionsdata.id) {
                                    this.state.integerQuestionsChemistrySelected.splice(i, 1);
                                    this.setState({ integerQuestionsChemistrySelected: this.state.integerQuestionsChemistrySelected });
                                }

                            }
                        } else {
                            for (var i in this.state.generalQuestionsChemistrySelected) {
                                if (this.state.generalQuestionsChemistrySelected[i].id == questionsdata.id) {
                                    this.state.generalQuestionsChemistrySelected.splice(i, 1);
                                    this.setState({ generalQuestionsChemistrySelected: this.state.generalQuestionsChemistrySelected });
                                }

                            }
                        }
                    } else if (this.state.qbsearchsubject == "5") {
                        if (questionsdata.qtype == "8") {
                            for (var i in this.state.integerQuestionsZoologySelected) {
                                if (this.state.integerQuestionsZoologySelected[i].id == questionsdata.id) {
                                    this.state.integerQuestionsZoologySelected.splice(i, 1);
                                    this.setState({ integerQuestionsZoologySelected: this.state.integerQuestionsZoologySelected });
                                }

                            }
                        } else {
                            for (var i in this.state.generalQuestionsZoologySelected) {
                                if (this.state.generalQuestionsZoologySelected[i].id == questionsdata.id) {
                                    this.state.generalQuestionsZoologySelected.splice(i, 1);
                                    this.setState({ generalQuestionsZoologySelected: this.state.generalQuestionsZoologySelected });
                                }

                            }
                        }
                    } else if (this.state.qbsearchsubject == "4") {
                        if (questionsdata.qtype == "8") {
                            for (var i in this.state.integerQuestionsMathsSelected) {
                                if (this.state.integerQuestionsMathsSelected[i].id == questionsdata.id) {
                                    this.state.integerQuestionsMathsSelected.splice(i, 1);
                                    this.setState({ integerQuestionsMathsSelected: this.state.integerQuestionsMathsSelected });
                                }

                            }
                        } else {
                            for (var i in this.state.generalQuestionsMathsSelected) {
                                if (this.state.generalQuestionsMathsSelected[i].id == questionsdata.id) {
                                    this.state.generalQuestionsMathsSelected.splice(i, 1);
                                    this.setState({ generalQuestionsMathsSelected: this.state.generalQuestionsMathsSelected });
                                }

                            }
                        }
                    }


                }
            }


            console.log("wwwwwwwwwwwwwwwwwww", this.state.generalQuestionsBotanySelected.length);

            subjectArray = this.state.subjects.map((subjectData) => {
                if (subjectData.id == this.state.qbsearchsubject) {

                    const chData = subjectData.chapters.map((chmapData) => {
                        if (chmapData.id == this.state.qbsearchchapter) {
                            if (e.target.checked == true) {
                                let array = chmapData.questionbarray;
                                array.push({ ...questionsdata });
                                return { ...chmapData, questionbarray: array }
                            }
                            else {
                                const questionbarray = chmapData.questionbarray.filter((a) => a.id != questionsdata.id);
                                //questionbarray.push(questionsdata);
                                return { ...chmapData, questionbarray: questionbarray }
                            }
                        }
                        return { ...chmapData }

                    })
                    return { ...subjectData, chapters: chData }
                }
                return { ...subjectData }
            });


        }


        this.setState({ subjects: subjectArray });

    }

    selecthandleInputChange = async (ename, evalue) => {

        console.log("selecthandleInputChange", ename, evalue);
        let name = "";
        const value = evalue;

        if (ename == "qbQuestionSearchSubject") {
            name = "qbsearchsubject"
        } else {
            name = ename;
        }

        console.log("namenamenamename", name);

        if (name == "qbsearchsubject") {
            let subjectData = this.state.subjects.find((a) => a.id == value);
            this.setState({
                qbsearchsubjectvalue: {
                    value: subjectData.id,
                    label: subjectData.subject
                },
                qbsearchchapter: "",
                qbsearchchaptervalue: "",
                qbsearchtopic: [],
                qbsearchtopicvalue: [],
                typeOfQuestion: "",
                typeOfQuestionvalue: "",
                complexity: "",
                complexityvalue: ""

            });

            setTimeout(() => {
                this.getChapters();
            }, 800);
        }

        if (name == "qbsearchchapter") {
            let subjectData = this.state.subjects.find((a) => a.id == this.state.qbsearchsubject);
            let chData = subjectData.chapters.find((a) => a.id == value);


            this.setState({
                qbsearchchaptervalue: {
                    value: chData.id,
                    label: chData.chapter
                },
                qbsearchtopic: [],
                qbsearchtopicvalue: []

            });

            setTimeout(() => {
                this.getTopics();
            }, 1000);
        }
        if (name == "typeOfQuestion") {
            let questionTypesData = this.props.globals.questionTypes.find((a) => a.id == value);
            console.log("typeOfQuestion", questionTypesData);
            if (this.state.exam_type == 1) {
                if (questionTypesData.id == 7) {
                    this.setState({
                        typeOfQuestionvalue: {
                            value: questionTypesData.id,
                            label: questionTypesData.questiontype
                        },

                    });
                }
            } else {
                this.setState({
                    typeOfQuestionvalue: {
                        value: questionTypesData.id,
                        label: questionTypesData.questiontype
                    },

                });
            }

        }
        if (name == "complexity") {
            let complexityData = this.props.globals.complexity.find((a) => a.id == value);
            this.setState({
                complexityvalue: {
                    value: complexityData.id,
                    label: complexityData.complexity
                },

            });
        }
        if (name == "class_id") {
            let classData = this.props.globals.classes.find((a) => a.id == value);
            this.setState({
                classvalue: {
                    value: classData.id,
                    label: classData.class
                },
                class_id: classData.id,
                submitError1: ""
            });
        }
        if (name == "exam_type") {
            let examTypeValues = this.props.globals.exams.find((a) => a.id == value);
            this.setState({
                examTypeValue: {
                    value: examTypeValues.id,
                    label: examTypeValues.exam
                }
            });
        }
        // if (name == "exam_type") {
        //     let examTypeValues = this.props.globals.exams.find((a) => a.id == value);
        //     this.setState({
        //         examTypeValue: {
        //             value: examTypeValues.id,
        //             label: examTypeValues.exam
        //         }
        //     });
        // }
        this.setState({ [name]: value });

    }

    handleInputChange = (e) => {
        console.log("handleInputChange", e.target.name, e.target.checked)

        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value, submitError1: "" });




    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("handleMultipleSelectInputChange", e, name);
        if (name == "topic") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            console.log("wwwwwwwwwwww", e)
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    qbsearchtopicvalue: qbsearchtopicvalue,
                    qbsearchtopic: qbsearchtopic
                });
            }
        }
        if (name == "sections") {
            let branchSelected = Array();
            let sectionSelected = Array();
            let sectionSelectedvalue = Array();
            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value
                    }
                    sectionSelectedvalue.push(newObj);
                    sectionSelected.push(sectionval.value);
                    branchSelected.push(sectionval.branch);
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    sectionSelected: sectionSelected,
                    branchSelected: branchSelected,
                    submitError1: ""
                });
            }
        }



    }

    ownedquestionClassFun1 = (e, data) => {
        console.log("owedqfilterclass", data);
        let classArray = this.state.classData_s.map((item) => {
            if (item.id == data) {
                return { ...item, active: "outline-secondary active" }
            }
            else {
                return { ...item, active: "outline-secondary" }
            }

        })
        this.setState({ classData_s: classArray, owedqfilterclass: data });
        this.setState({
            qbsearchchapter: "0",
            qbsearchchaptervalue: "",
            qbsearchtopic: [],
            qbsearchtopicvalue: [],
            typeOfQuestion: "0",
            typeOfQuestionvalue: "",
            complexity: "0",
            complexityvalue: "",
            getQuestionBankQuestions: "",
            validateSubject: "",
            validateChapter: "",
            validateTopic: "",
            validateTypeOfQuestion: "",
            validateComplexity: "",
            checkedVall: false,
            activePage: 1,
            totalItemsCount: 0,
            itemsCountPerPage: 10,
            showSpinner: "hide",

            submitError1: "",
            formErrors: {
                exam_type: "",
                branch: "",
                class: "",
                section: "",
                exam_name: "",
                eamcetExamType: "",
                timeduration: ""
            },
            paginationShowBlock: "",
            showQuestionsNotAvailable: "yes"

        });

        setTimeout(() => {
            this.getChapters();
        }, 500);
    }

    onScrollgetQuestionById = async () => {
        this.setState({ validateSubject: "", validateChapter: "", validateTopic: "", validateTypeOfQuestion: "", validateComplexity: "", getQuestionBankQuestions: "", showSpinner: "hide", validationMessage: "", qbQuestionSearchSubject: "0", showQuestionsNotAvailable: "yes" });

        if (this.state.qbsearchsubjectvalue == "") {
            this.setState({ validateSubject: "Please Select Subject" });
            return;
        } else if (this.state.qbsearchchaptervalue == "") {
            this.setState({ validateChapter: "Please Select Chapter" });
            return;
        } else if (this.state.qbsearchtopicvalue == "") {
            this.setState({ validateTopic: "Please Select Topic" });
            return;
        }
        /*else if(this.state.typeOfQuestionvalue == ""){
            this.setState({validateTypeOfQuestion:"Please Select Type of Question" });
            return;
        }
        else if(this.state.complexityvalue == ""){
            this.setState({validateComplexity:"Please Select Complexity" });
            return;
        }*/

        let uniqueTopicArr = [...new Set(this.state.qbsearchtopic)];

        this.setState({ showSpinner: "show" });

        const result = await this.props.client.query({
            query: gql` 
        query(
            $subject:String!,
            $chapter:String!,
            $topic:String!,
            $question_type:String,
            $question_theory:String,
            $complexity: String,
            $institute_id: Int!,
            $page: Int,
            $type: Int, 
            $exam_type:Int
            
            ) {
                getQuestionBankQuestions(
                    subject: $subject,
                    chapter: $chapter,
                    topic: $topic,
                    question_type: $question_type,
                    question_theory: $question_theory,
                    complexity:$complexity,
                    institute_id: $institute_id,
                    page:$page,
                    type: $type,
                    exam_type:$exam_type
                )
                {
                    id
                    subject
                    question
                    chapter
                    topic
                    complexity
                    question_theory
                    qtype
                    mat_question
                    compquestion
                    list1type
                    list2type
                    subject_name
                    chapter_name
                    topic_name
                    option1
                    option2
                    option3
                    option4
                    answer
                    usageset
            }
        }
    `,
            variables: {

                subject: this.state.qbsearchsubject,
                chapter: this.state.qbsearchchapter,
                topic: uniqueTopicArr.toString(),
                question_type: this.state.typeOfQuestion,
                question_theory: "0",
                complexity: this.state.complexity,
                institute_id: parseInt(Cookies.get("institutionid")),
                page: 1,
                type: 1,
                exam_type: parseInt(this.state.exam_type)

            },
            fetchPolicy: 'network-only'
        });

        console.log("aaaaa", result);

        if (result.data.getQuestionBankQuestions.length > 0) {
            console.log("wwwwwwww", result.data.getQuestionBankQuestions)
            this.setState({
                showSpinner: "hide",
                getQuestionBankQuestions: result.data.getQuestionBankQuestions,
                showQuestionsNotAvailable: "yes"
            });
        } else {
            console.log("wwwwwwww1", result.data.getQuestionBankQuestions)
            this.setState({
                showQuestionsNotAvailable: "no",
                getQuestionBankQuestions: "",
                showSpinner: "hide"
            });
        }

    }

    idFunction(data) {
        let id = parseInt(data + 1);
        return id;
    }

    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    quentionSearchhandleChange = (e) => {
        this.setState({
            qbsearchsubject: e.target.value
        });

    }

    removeHTML = (question) => {
        var tmp = document.createElement("p");
        tmp.innerHTML = question;
        return tmp.textContent || tmp.innerText || "";
    }

    actionFormatterLearn(cell, row, rowIndex) {

        if (row.Questions.qtype == "9" || row.Questions.qtype == "3") {
            console.log("questionsData.question", row.Questions.question, row.Questions.id);
            let question1 = row.Questions.question.replace(/src="/g, 'src=\\"');
            let question2 = question1.replace(/" \/>/g, '\\" />');
            let question = [];
            try {
                question = JSON.parse(question2);
            }
            catch (err) {
                console.log("MATRIX ERROR:", err.message);
            }

            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Form.Check type="checkbox" id={"checkbox_1001" + rowIndex} custom>
                        {
                            row.Questions.checked == true ?
                                (<Form.Check.Input type="checkbox" checked={row.Questions.checked} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                                :
                                (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                        }
                        <Form.Check.Label htmlFor={"checkbox_1001" + rowIndex}>
                            {parse(row.Questions.mat_question)}
                            <p className='font-weight-bold'>{" QID- " + row.Questions.id}</p>
                            <Row>
                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                    <ol className="matrixlistoptions" type={
                                        row.Questions.list1type == "alphabets" ? ("A")
                                            : (row.Questions.list1type == "numbers") ? ("1")
                                                : ("roman")}
                                    >
                                        {question.map((item) => (
                                            <li>{parse(item.qlist1)}</li>
                                        ))}
                                    </ol>
                                </Col>
                                <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                                    <ol className="matrixlistoptions" type={
                                        row.Questions.list2type == "alphabets" ? ("A")
                                            : (row.Questions.list2type == "numbers") ? ("1")
                                                : ("roman")}>
                                        {question.map((item) => (
                                            <li>{parse(item.qlist2)}</li>
                                        ))}
                                    </ol>
                                </Col>
                            </Row>
                        </Form.Check.Label>
                    </Form.Check>
                    <hr className="my-3" />
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(row.Questions.option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(row.Questions.option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(row.Questions.option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(row.Questions.option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Currect Answer:</span>
                                <div className="font-weight-bold ml-2">{row.Questions.answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>)
        }
        else if (row.Questions.qtype == "8") {
            // console.log("questionsData.questionnn", question);
            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Form.Check type="checkbox" id={"checkbox_2011" + rowIndex} custom>
                        {
                            row.Questions.checked == true ?
                                (<Form.Check.Input type="checkbox" checked={row.Questions.checked} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                                :
                                (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                        }
                        <Form.Check.Label htmlFor={"checkbox_2011" + rowIndex}>
                            {parse(row.Questions.question)}
                            <p className='font-weight-bold'>{" QID- " + row.Questions.id}</p>
                        </Form.Check.Label>
                    </Form.Check>
                    <hr className="my-3" />
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Currect Answer:</span>
                                <div className="font-weight-bold ml-2">{row.Questions.answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )

        }
        else if (row.Questions.qtype == "5") {
            //console.log("questionsData.questionnn", question);
            return (<Card as={Card.Body} className="bg-light my-2">
                <Form.Check type="checkbox" id={"checkbox_3021" + rowIndex} custom>
                    {
                        row.Questions.checked == true ?
                            (<Form.Check.Input type="checkbox" checked={row.Questions.checked} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                            :
                            (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                    }
                    <Form.Check.Label htmlFor={"checkbox_3021" + rowIndex}>
                        {parse(row.Questions.compquestion)}
                        {parse(row.Questions.question)}
                        <p className='font-weight-bold'>{" QID- " + row.Questions.id}</p>
                    </Form.Check.Label>
                </Form.Check>
                <hr className="my-3" />
                <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>A.</span>
                            <div className="ml-2">{parse(row.Questions.option1)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>B.</span>
                            <div className="ml-2">{parse(row.Questions.option2)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>C.</span>
                            <div className="ml-2">{parse(row.Questions.option3)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>D.</span>
                            <div className="ml-2">{parse(row.Questions.option4)}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
                        <div className="d-flex align-items-center color_000">
                            <span className="font-weight-bold">Currect Answer:</span>
                            <div className="font-weight-bold ml-2">{row.Questions.answer}</div>
                        </div>
                    </Col>
                </Row>

            </Card>)
        }
        else {
            // console.log("questionsData.questionnn", question);
            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Form.Check type="checkbox" id={"checkbox_4031" + rowIndex} custom>
                        {
                            row.Questions.checked == true ?
                                (<Form.Check.Input type="checkbox" checked={row.Questions.checked} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                                :
                                (<Form.Check.Input type="checkbox" checked={this.state.checkedVall} onChange={(e) => { this.QuestionFunction(e, row.Questions, "qbank"); }} />)
                        }
                        <Form.Check.Label htmlFor={"checkbox_4031" + rowIndex}>
                            {parse(row.Questions.question)}
                            <p className='font-weight-bold'>{" QID- " + row.Questions.id}</p>
                        </Form.Check.Label>
                    </Form.Check>
                    <hr className="my-3" />
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(row.Questions.option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(row.Questions.option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(row.Questions.option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(row.Questions.option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Currect Answer:</span>
                                <div className="font-weight-bold ml-2">{row.Questions.answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }


    }


    questionsTable = (data) => {
        let dataArr = [];
        data.map((questionsData, index) => {
            const obj = {
                Questions: questionsData
            }
            dataArr.push(obj)

        })
        return dataArr;
    }

    colFunction = [
        {
            dataField: "Questions",
            text: "Questions",
            formatter: this.actionFormatterLearn.bind(this)

        }
    ];

    datefunction = (moment1, name) => {
        console.log("datefunction", moment1._d, name);
        let date = String(moment1._d);
        var res = date.substr(4, 20);
        let add3Hours = moment(moment1).add(3, 'hours').format("DD-MM-YYYY LT");
        let autoEndDate = moment(moment1).add(3, 'hours').format("MMM DD YYYY HH:mm:ss");
        console.log("addHours", add3Hours)
        this.setState({ startdate: res, add3Hours_val: add3Hours, enddate: autoEndDate });

        this.setState({
            submitError1: ""
        });

        console.log("addHours", this.state.add3Hours_val)
    }
    datefunctionend = (moment1, name) => {
        console.log("datefunction", moment1._d, name);
        let date = String(moment1._d);
        var res = date.substr(4, 20);
        let add3Hours = moment(res).format("DD-MM-YYYY LT");
        this.setState({ enddate: res, add3Hours_val: add3Hours });

        this.setState({
            submitError1: ""
        });
    }

    showQuestionGenerateModal = (e, paper_generate_type) => {
        if (paper_generate_type == "save") {
            if (this.state.complexity_type_str == "custom") {
                if (this.state.custom_easy_val == "" || this.state.custom_modarate_val == "" || this.state.custom_difficult_val == "") {
                    this.setState({ validateCustomInputValues: "Please Enter Values" });
                    return;
                }
            }
            this.setState({ modalShow: true, submitError1: "", paper_generate_type: paper_generate_type })
        } else {
            this.setState({ modalShow: true, submitError1: "", paper_generate_type: paper_generate_type })
        }


    }

    handleFormSubmit = (e, question_paper_save_type) => {


        if (this.state.exam_name == "" && question_paper_save_type != "Draft") {
            this.setState({
                submitError1: "Please enter exam name"
            })
            return ""
        }

        if (this.state.class_id == "" && question_paper_save_type != "Draft") {
            this.setState({
                submitError1: "Please select class"
            })
            return ""
        }

        if (this.state.sectionSelected.length == "0" && question_paper_save_type != "Draft") {
            this.setState({
                submitError1: "Please select Section"
            })
            return ""
        }

        if (this.state.startdate == "" && question_paper_save_type != "Draft") {
            this.setState({
                submitError1: "Please select Start Time"
            })
            return ""
        }


        this.setState({
            isSubmitting: true
        })


        e.preventDefault();

        this.setState({
            spinnerStatus: "1"
        });
        setTimeout(() => {

            let stateSyllabus = this.state.subjects;
            let syllabusArray = [];
            let qbankQuestion = [];
            let q_types_for_quesBank_insBank = [];
            let is_part_exam = "0", exam_model_id = 0, mains_2021 = "0";
            let sub_exam_type_val = 0;
            let sectionsArr = [];
            let branchArr = [];
            for (let i = 0; i < stateSyllabus.length; i++) {

                let idata = stateSyllabus[i];
                let totalchapters = idata.chapters;
                let topicArray = [];
                for (let x = 0; x < totalchapters.length; x++) {
                    let tdata = totalchapters[x];

                    if (tdata.questionbarray.length > 0) {
                        tdata.questionbarray.map((questionbarraymapData) => {
                            const newquestionId = questionbarraymapData;
                            qbankQuestion.push(parseInt(newquestionId.id));
                            q_types_for_quesBank_insBank.push(parseInt(newquestionId.qtype));
                        })

                    }

                    let totaltopics = tdata.topics;

                    for (let y = 0; y < totaltopics.length; y++) {
                        let ttdata = totaltopics[y];
                        console.log("ttdata", ttdata);
                        if (ttdata.checked == true) {
                            let newtopic = ttdata.id;
                            console.log("newtopic", newtopic);
                            topicArray.push(newtopic);

                        }
                    }


                }
                console.log("topicArray", topicArray);
                const newSyllabus = {
                    subject_id: parseInt(idata.id),
                    chapters: [],
                    topics: topicArray
                }
                syllabusArray.push(newSyllabus);
            }
            console.log("qbankQuestion", qbankQuestion);

            let newArray = syllabusArray.filter(item =>
                item.topics.length > 0
            )

            console.log('newArray', newArray);
            let startdate = "";
            if (this.state.startdate == "") {

                startdate = moment().format("DD-MM-YYYY HH:mm:ss");
            }
            else {
                startdate = this.state.startdate;
            }

            let enddate = "";
            if (this.state.enddate == "") {
                enddate = moment().format("DD-MM-YYYY HH:mm:ss");
            }
            else {
                enddate = this.state.enddate;
            }
            let examtypema = "";
            if (this.state.exam_type == "2" || this.state.otherexam == "2") {
                examtypema = this.state.exam_type;
            } else {
                examtypema = "0";
            }

            let exam_type = "";
            if (this.state.exam_type == "5") {
                exam_type = this.state.otherexam;
            } else {
                exam_type = this.state.exam_type;
            }

            let autogenerate = true
            if (this.state.generate_type != "1") {
                autogenerate = false
            }
            if (this.state.exam_type == 1) {
                exam_model_id = parseInt(this.state.pattern_type);
                sub_exam_type_val = 0;
                mains_2021 = "0";
            } else if (this.state.exam_type == 2) {
                mains_2021 = this.state.jee_pattern_type;
                sub_exam_type_val = 1;
            } else {
                exam_model_id = 0;
                mains_2021 = "0";
                sub_exam_type_val = 0;
            }

            let complexity_type = 0, complexity_custom_values = [];


            console.log("ddddddddd", this.state.sectionSelected)
            for (let i = 0; i < this.state.sectionSelected.length; i++) {
                sectionsArr.push(parseInt(this.state.sectionSelected[i]));
            }
            for (let i = 0; i < this.state.branchSelected.length; i++) {
                branchArr.push(parseInt(this.state.branchSelected[i]));
            }

            let pattern_type = 3;

            if (this.state.jee_pattern_type != 3 && this.state.pattern_type != 3) {

                if (exam_type == 1) {
                    pattern_type = this.state.pattern_type
                } else {
                    if (this.state.jee_pattern_type != 0) {
                        pattern_type = 2
                    } else {
                        pattern_type = 0
                    }
                }
            }

            let creategeneralpaper = "";
            creategeneralpaper = {
                syllabus: newArray,
                exam_name: this.state.exam_name,
                exam_type: parseInt(exam_type),
                exam_class_id: 0,
                class_id: parseInt(this.state.class_id),
                exam_model_id: exam_model_id,
                mains_2021: mains_2021.toString(),
                branch: branchArr.toString(),
                section: sectionsArr.toString(),
                sub_exam_type: parseInt(examtypema),
                no_of_sets: parseInt(this.state.noofsets),
                start_time: startdate,
                end_time: enddate,
                pattern_type: pattern_type,
                institution_id: parseInt(Cookies.get("institutionid")),
                username: Cookies.get("username"),
                autogenerate: autogenerate,
                questionbank_questions: qbankQuestion.toString(),
                question_type: q_types_for_quesBank_insBank.toString(),
                complexity_type: complexity_type,
                complexity_custom_values: complexity_custom_values.toString(),
                type: "group_custom"
            }
            console.log("paper", creategeneralpaper);
            const question_count = this.state.subjects.map((a) => {
                return {
                    subject_id: parseInt(a.id),
                    question_count: parseInt(0)
                }
            });
            console.log('creategeneralpaper', creategeneralpaper,
                parseInt(this.state.timeduration),
                question_count);

            if (question_paper_save_type == "Save") {
                this.createExamMadeEasyPaper(
                    creategeneralpaper,
                    parseInt(this.state.timeduration),
                    question_count,
                    this.state.examPaperId
                ).catch(error => {
                    console.log("catch if error");
                    console.log(error);
                    this.setState({
                        submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: "", isSubmitting: false
                    });
                    console.error("ERR =>", error.graphQLErrors.map(x => x.message));
                });
            } else {
                this.examMadeEasyDraftPapers(
                    creategeneralpaper,
                    parseInt(this.state.timeduration),
                    question_count,
                    this.state.examPaperId
                ).catch(error => {
                    console.log("catch if error");
                    console.log(error);
                    this.setState({
                        submitError1: error.graphQLErrors.map(x => x.message), spinnerStatus: "", isSubmitting: false
                    });
                    console.error("ERR =>", error.graphQLErrors.map(x => x.message));
                });
            }

        }, 1000);
    };

    createExamMadeEasyPaper = async (
        params,
        time_duration,
        question_count,
        examPaperId
    ) => {
        await this.props.createExamMadeEasyPaper({
            variables: {
                params,
                time_duration,
                question_count,
                examPaperId
            },
            update: (store, { data }) => {
                console.log("createGeneralPaperdata", data);
                if (data.createExamMadeEasyPaper) {
                    let tcq = 0;
                    let totalExamCount3 = "";

                    if (this.state.eamcetExamType == "3" || this.state.eamcetExamType == "6" || this.state.eamcetExamType == "7" || this.state.eamcetExamType == "8") {

                        this.state.subjects.map((item) => {
                            tcq = tcq + item.qcount
                        });

                        let eduration = this.props.globals.exams.find((a) => a.id == this.state.eamcetExamType);
                        console.log("eduration", eduration);

                        if (eduration != undefined) {
                            totalExamCount3 = parseFloat(eduration.avg_question_time) * parseFloat(tcq);
                        }
                    }
                    console.log("tcqtotalExamCount3", tcq, totalExamCount3);
                    this.setState({
                        currentStep: 5,

                        submitError1: "",

                        filename: data.createExamMadeEasyPaper.filename,
                    });
                    this.props.history.push({
                        pathname: "/questions/manage-question-paper",
                    });


                }
            }
        });
    };

    examMadeEasyDraftPapers = async (
        params,
        time_duration,
        question_count,
        examPaperId
    ) => {
        await this.props.examMadeEasyDraftPapers({
            variables: {
                params,
                time_duration,
                question_count,
                examPaperId
            },
            update: (store, { data }) => {
                console.log("createGeneralPaperdata", data);
                if (data.examMadeEasyDraftPapers) {
                    let tcq = 0;
                    let totalExamCount3 = "";

                    if (this.state.eamcetExamType == "3" || this.state.eamcetExamType == "6" || this.state.eamcetExamType == "7" || this.state.eamcetExamType == "8") {

                        this.state.subjects.map((item) => {
                            tcq = tcq + item.qcount
                        });

                        let eduration = this.props.globals.exams.find((a) => a.id == this.state.eamcetExamType);
                        console.log("eduration", eduration);

                        if (eduration != undefined) {
                            totalExamCount3 = parseFloat(eduration.avg_question_time) * parseFloat(tcq);
                        }
                    }
                    console.log("tcqtotalExamCount3", tcq, totalExamCount3);
                    this.setState({
                        currentStep: 5,
                        submitError1: "",
                        filename: data.examMadeEasyDraftPapers.filename,
                    });
                    this.props.history.push({
                        pathname: "/exam_made_easy/draft_question_view/DraftQuestionsView",
                    });

                }
            }
        });
    };

    render() {
        let examDetailsForDraftPatternType = this.props.location.state.examDetails;
        this.state.pattern_type = examDetailsForDraftPatternType.exam_model_id;
        this.state.jee_pattern_type = examDetailsForDraftPatternType.mains_2021;
        this.state.exam_type = examDetailsForDraftPatternType.exam_type;

        console.log("props.examDetails", this.state.jee_pattern_type, this.state.pattern_type);

        if (this.state.exam_type == 1) {
            if (this.state.pattern_type == 0) {
                this.state.generalQuestionsCount = 44
            } else {
                this.state.generalQuestionsCount = 49
            }

        } else if (this.state.exam_type == 2) {
            if (this.state.jee_pattern_type == 0) {
                this.state.generalQuestionsCount = 19
                this.state.integerQuestionCount = 4
            } else {
                this.state.generalQuestionsCount = 19
                this.state.integerQuestionCount = 9
            }
        } else if (this.state.exam_type == 3 || this.state.exam_type == 6) {
            this.state.generalQuestionsCount = 39

        } else if (this.state.exam_type == 7 || this.state.exam_type == 8) {
            this.state.generalQuestionsCount = 39
        }

        console.log("this.props.stateDatadddddddddddddddddddd", this.props);
        if (this.state.subjectWiseSelectedQus == "") {
            this.state.subjects.map((subject) => {
                const generalQuestionsLen = [], intergerQuestionLen = [];
                this.props.history.location.state.examDetails.exam_questions.filter(item => subject.id == item.subject).map((item1, index) => {
                    if (item1.qtype != 8) {
                        generalQuestionsLen.push(item1);
                        if (subject.id == 1) {//botany
                            this.state.generalQuestionsBotanySelected.push(item1)
                        } else if (subject.id == 5) {//zoology
                            this.state.generalQuestionsZoologySelected.push(item1)
                        } else if (subject.id == 2) {//physics
                            this.state.generalQuestionsPhysicsSelected.push(item1)
                        } else if (subject.id == 3) {//chemistry
                            this.state.generalQuestionsChemistrySelected.push(item1)
                        } else if (subject.id == 4) {//Maths
                            this.state.generalQuestionsMathsSelected.push(item1)
                        }
                    } else if (item1.qtype == 8) {
                        intergerQuestionLen.push(item1);
                        if (subject.id == 1) {//botany
                            this.state.integerQuestionsBotanySelected.push(item1)
                        } else if (subject.id == 5) {//zoology
                            this.state.integerQuestionsZoologySelected.push(item1)
                        } else if (subject.id == 2) {//physics
                            this.state.integerQuestionsPhysicsSelected.push(item1)
                        } else if (subject.id == 3) {//chemistry
                            this.state.integerQuestionsChemistrySelected.push(item1)
                        } else if (subject.id == 4) {//Maths
                            this.state.integerQuestionsMathsSelected.push(item1)
                        }
                    }


                });

                var obj = {
                    subject_name: subject.subject,
                    generalQuestions: generalQuestionsLen.length,
                    intergerQuestions: intergerQuestionLen.length
                }

                this.state.subjectWiseSelectedQus.push(obj);

            });
        }

        let topicselectall = true;
        let topiclabelledBy = "Select";
        let topicdisableSearch = false;
        if (this.state.getTopicsArr.length > 0) {
            topicselectall = true;
            topicdisableSearch = false;
        }
        else {
            topicdisableSearch = true;
            topicselectall = false;
            topiclabelledBy = "Topics"
        }

        let finddata = [];
        let newData1 = [];
        let latestData = [];


        if (this.state.getQuestionBankQuestions.length > 0) {
            this.state.getQuestionBankQuestions.map((item) => {
                this.state.subjects.map((item1) => {
                    if (parseInt(item1.id) == parseInt(item.subject)) {
                        item1.chapters.map((item3) => {

                            const arr = item.chapter;
                            console.log("sssss", arr)
                            if (arr.includes(item3.id.toString())) {
                                if (item3.questionbarray.length > 0) {
                                    finddata = item3.questionbarray
                                    console.log("find", finddata);
                                }
                            }

                        })
                    }
                })
            });


            if (finddata.length > 0) {

                newData1 = this.state.getQuestionBankQuestions.map((item) => {

                    if (finddata.length > 0) {

                        if (finddata.find((a) => a.id == item.id)) {
                            return { ...item, checked: true }
                        }
                        else {
                            return { ...item, checked: false }
                        }
                    }


                })

            }

            if (newData1.length > 0) {
                latestData = newData1
                // latestData = newData1.filter((a) => a.id.includes(this.state.qbsearchsubject));
            } else {
                //latestData = this.state.getInstituteQuestions;
                latestData = this.state.getQuestionBankQuestions.filter((a) => a.id.includes(this.state.qbsearchsubject));
            }




        }

        console.log("latestDatalatestData", latestData)
        return (
            <Container fluid className='exam_made_easy'>
                <Row>
                    <Col sm={12}>
                        <h4 className='text-center'>Question Paper Generation</h4>
                    </Col>
                </Row>
                <Row>
                    <Col sm={8} className='mt-3'>
                        <Card as={Card.Body} className='block_white'>
                            <Row>
                                <Col sm={12}>
                                    <h6 className='text-center'>Exam Name : {this.state.exam_name}</h6>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col sm={6} className='mt-2'>
                                    <Form.Group as={Col} sm={12} controlId="eamcetExamType">
                                        <Form.Label className="font-weight-bold">Exam Type <span className='errorCls'>{this.state.validateExamType}</span></Form.Label>
                                        <SelectBoxWithDisabledOption
                                            stateData={this.state.exam_typeValue}
                                            handleChange={this.selecthandleInputChange}
                                            name="exam_type"
                                            isDisabled={'true'}
                                            options={this.state.examTypeOptions}
                                            placeholderName={'Exam Type'}
                                            dropdownIndicator={{ DropdownIndicator }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6} className='mt-2'>

                                    {
                                        this.state.exam_type == 1 ?
                                            (
                                                <>
                                                    <h6 className='f-16 mb-2'>Pattern type</h6>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            type="radio"
                                                            id="patterntype1"
                                                            value="0"
                                                            name="pattern_type"
                                                            className="custom-control-input"
                                                            defaultChecked={this.state.pattern_type == 0 ? true : false}
                                                            disabled={this.state.pattern_type == 0 ? false : true}
                                                        />

                                                        <label
                                                            className="custom-control-label font-weight-bold"
                                                            htmlFor="patterntype1"
                                                        >
                                                            Old NTA Pattern
                                                        </label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            type="radio"
                                                            id="patterntype2"
                                                            value="2"
                                                            name="pattern_type"
                                                            className="custom-control-input"
                                                            defaultChecked={this.state.pattern_type == 2 ? true : false}
                                                            disabled={this.state.pattern_type == 2 ? false : true}
                                                        />

                                                        <label
                                                            className="custom-control-label  font-weight-bold"
                                                            htmlFor="patterntype2"
                                                        >
                                                            New NTA Pattern
                                                        </label>
                                                    </div>
                                                    <div className="custom-control custom-radio custom-control-inline">
                                                        <input
                                                            type="radio"
                                                            id="patterntype3"
                                                            value="3"
                                                            name="pattern_type"
                                                            className="custom-control-input"
                                                            defaultChecked={this.state.pattern_type == 3 ? true : false}
                                                            disabled={this.state.pattern_type == 3 ? false : true}
                                                        />

                                                        <label
                                                            className="custom-control-label  font-weight-bold"
                                                            htmlFor="patterntype3"
                                                        >
                                                            Custom Pattern
                                                        </label>
                                                    </div>
                                                </>
                                            )
                                            :
                                            (
                                                this.state.exam_type == 2 ? (
                                                    <>
                                                        <h6 className='f-16 mb-2'>Pattern type</h6>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input
                                                                type="radio"
                                                                id="jeePatternType1"
                                                                value="0"
                                                                name="jee_pattern_type"
                                                                className="custom-control-input"
                                                                defaultChecked={parseInt(this.state.jee_pattern_type) == 0 ? true : false}
                                                                disabled={parseInt(this.state.jee_pattern_type) == 0 ? false : true}
                                                            />

                                                            <label
                                                                className="custom-control-label font-weight-bold"
                                                                htmlFor="jeePatternType1"
                                                            >
                                                                Old NTA Pattern
                                                            </label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input
                                                                type="radio"
                                                                id="jeePatternType2"
                                                                value="1"
                                                                name="jee_pattern_type"
                                                                className="custom-control-input"
                                                                defaultChecked={parseInt(this.state.jee_pattern_type) == 1 ? true : false}
                                                                disabled={parseInt(this.state.jee_pattern_type) == 1 ? false : true}
                                                            />

                                                            <label
                                                                className="custom-control-label  font-weight-bold"
                                                                htmlFor="jeePatternType2"
                                                            >
                                                                New NTA Pattern
                                                            </label>
                                                        </div>
                                                        <div className="custom-control custom-radio custom-control-inline">
                                                            <input
                                                                type="radio"
                                                                id="jeePatternType3"
                                                                value="1"
                                                                name="jee_pattern_type"
                                                                className="custom-control-input"
                                                                defaultChecked={parseInt(this.state.jee_pattern_type) == 3 ? true : false}
                                                                disabled={parseInt(this.state.jee_pattern_type) == 3 ? false : true}
                                                            />

                                                            <label
                                                                className="custom-control-label  font-weight-bold"
                                                                htmlFor="jeePatternType3"
                                                            >
                                                                Custom Pattern
                                                            </label>
                                                        </div>
                                                    </>
                                                ) : (""))
                                    }

                                </Col>

                            </Row>
                            <Row>
                                {
                                    this.state.exam_type == "3" || this.state.exam_type == "6" || this.state.exam_type == "7" || this.state.exam_type == "8" ?
                                        (
                                            <>

                                                <Col sm={6} className='mt-2'>
                                                    <Form.Group as={Col} sm={8} controlId="eamcetExamType">
                                                        <Form.Label className="font-weight-bold">Max Question Time (Sec/Q) </Form.Label>
                                                        <Form.Control
                                                            style={{ width: 150 }}
                                                            type="text"
                                                            placeholder="duration"
                                                            name="timeduration"
                                                            onChange={this.handleInputChange}
                                                            autoComplete="off"
                                                            value={this.state.timeduration}
                                                        />
                                                        <Form.Text className="form-text text-danger">
                                                            {this.state.formErrors.timeduration}
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </>

                                        )
                                        :
                                        ("")
                                }


                            </Row>

                        </Card>

                        <>
                            <h6 className="text-uppercase mt-4">Question Bank Questions</h6>
                            <Card as={Card.Body} className='block_white custom_setup'>
                                {
                                    this.state.generate_type == "2" ?
                                        (
                                            <>
                                                <h6 className="mt-3">Subject Wise Questions Selected: </h6>
                                                <div className="table-responsive your_css_class_here" >
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Subject</th>
                                                                <th>General Questions</th>
                                                                {
                                                                    this.state.exam_type == 2 ?
                                                                        (<th>Integer Questions</th>) : ("")
                                                                }

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.subjects.map((item) =>
                                                                    <tr>
                                                                        <td>{item.subject}</td>

                                                                        {
                                                                            item.id == 1 ?
                                                                                (
                                                                                    <td>
                                                                                        {this.state.generalQuestionsBotanySelected.length}
                                                                                        {
                                                                                            this.state.exam_type == 1 ?
                                                                                                (
                                                                                                    <>
                                                                                                        {
                                                                                                            this.state.pattern_type == 0 ?
                                                                                                                (
                                                                                                                    this.state.generalQuestionsBotanySelected.length > 44 ?
                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                )
                                                                                                                :
                                                                                                                (
                                                                                                                    this.state.generalQuestionsBotanySelected.length > 49 ?
                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                )
                                                                                                        }
                                                                                                    </>
                                                                                                )
                                                                                                :
                                                                                                (
                                                                                                    this.state.exam_type == 2 ?
                                                                                                        (
                                                                                                            this.state.generalQuestionsBotanySelected.length > 19 ?
                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                        )
                                                                                                        :
                                                                                                        (
                                                                                                            this.state.generalQuestionsBotanySelected.length > 39 ?
                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                        )

                                                                                                )
                                                                                        }
                                                                                    </td>
                                                                                )
                                                                                :
                                                                                (
                                                                                    <>
                                                                                        {
                                                                                            item.id == 5 ?
                                                                                                (
                                                                                                    <td>
                                                                                                        {this.state.generalQuestionsZoologySelected.length}
                                                                                                        {
                                                                                                            this.state.exam_type == 1 ?
                                                                                                                (
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            this.state.pattern_type == 0 ?
                                                                                                                                (
                                                                                                                                    this.state.generalQuestionsZoologySelected.length > 44 ?
                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                )
                                                                                                                                :
                                                                                                                                (
                                                                                                                                    this.state.generalQuestionsZoologySelected.length > 49 ?
                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                )
                                                                                                                        }
                                                                                                                    </>
                                                                                                                )
                                                                                                                :
                                                                                                                (
                                                                                                                    this.state.exam_type == 2 ?
                                                                                                                        (
                                                                                                                            this.state.generalQuestionsZoologySelected.length > 19 ?
                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                        )
                                                                                                                        :
                                                                                                                        (
                                                                                                                            this.state.generalQuestionsZoologySelected.length > 39 ?
                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                        )

                                                                                                                )
                                                                                                        }
                                                                                                    </td>
                                                                                                )
                                                                                                :
                                                                                                (
                                                                                                    <>
                                                                                                        {
                                                                                                            item.id == 2 ?
                                                                                                                (
                                                                                                                    <td>
                                                                                                                        {this.state.generalQuestionsPhysicsSelected.length}
                                                                                                                        {
                                                                                                                            this.state.exam_type == 1 ?
                                                                                                                                (
                                                                                                                                    <>
                                                                                                                                        {
                                                                                                                                            this.state.pattern_type == 0 ?
                                                                                                                                                (
                                                                                                                                                    this.state.generalQuestionsPhysicsSelected.length > 44 ?
                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                )
                                                                                                                                                :
                                                                                                                                                (
                                                                                                                                                    this.state.generalQuestionsPhysicsSelected.length > 49 ?
                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                )
                                                                                                                                        }
                                                                                                                                    </>
                                                                                                                                )
                                                                                                                                :
                                                                                                                                (
                                                                                                                                    this.state.exam_type == 2 ?
                                                                                                                                        (
                                                                                                                                            this.state.generalQuestionsPhysicsSelected.length > 19 ?
                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                        )
                                                                                                                                        :
                                                                                                                                        (
                                                                                                                                            this.state.generalQuestionsPhysicsSelected.length > 39 ?
                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                        )

                                                                                                                                )
                                                                                                                        }
                                                                                                                    </td>)
                                                                                                                :
                                                                                                                (
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            item.id == 4 ?
                                                                                                                                (
                                                                                                                                    <td>
                                                                                                                                        {this.state.generalQuestionsMathsSelected.length}
                                                                                                                                        {
                                                                                                                                            this.state.exam_type == 1 ?
                                                                                                                                                (
                                                                                                                                                    <>
                                                                                                                                                        {
                                                                                                                                                            this.state.pattern_type == 0 ?
                                                                                                                                                                (
                                                                                                                                                                    this.state.generalQuestionsMathsSelected.length > 44 ?
                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                )
                                                                                                                                                                :
                                                                                                                                                                (
                                                                                                                                                                    this.state.generalQuestionsMathsSelected.length > 49 ?
                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                )
                                                                                                                                                        }
                                                                                                                                                    </>
                                                                                                                                                )
                                                                                                                                                :
                                                                                                                                                (
                                                                                                                                                    this.state.exam_type == 2 ?
                                                                                                                                                        (
                                                                                                                                                            this.state.generalQuestionsMathsSelected.length > 19 ?
                                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                        )
                                                                                                                                                        :
                                                                                                                                                        (
                                                                                                                                                            this.state.generalQuestionsMathsSelected.length > 79 ?
                                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                        )

                                                                                                                                                )
                                                                                                                                        }
                                                                                                                                    </td>
                                                                                                                                )
                                                                                                                                :
                                                                                                                                (
                                                                                                                                    <>
                                                                                                                                        {
                                                                                                                                            item.id == 3 ?
                                                                                                                                                (
                                                                                                                                                    <td>
                                                                                                                                                        {this.state.generalQuestionsChemistrySelected.length}
                                                                                                                                                        {
                                                                                                                                                            this.state.exam_type == 1 ?
                                                                                                                                                                (
                                                                                                                                                                    <>
                                                                                                                                                                        {
                                                                                                                                                                            this.state.patterntype == 0 ?
                                                                                                                                                                                (
                                                                                                                                                                                    this.state.generalQuestionsChemistrySelected.length > 44 ?
                                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                                )
                                                                                                                                                                                :
                                                                                                                                                                                (
                                                                                                                                                                                    this.state.generalQuestionsChemistrySelected.length > 49 ?
                                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                                )
                                                                                                                                                                        }
                                                                                                                                                                    </>
                                                                                                                                                                )
                                                                                                                                                                :
                                                                                                                                                                (
                                                                                                                                                                    this.state.exam_type == 2 ?
                                                                                                                                                                        (
                                                                                                                                                                            this.state.generalQuestionsChemistrySelected.length > 19 ?
                                                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                        )
                                                                                                                                                                        :
                                                                                                                                                                        (
                                                                                                                                                                            this.state.generalQuestionsChemistrySelected.length > 39 ?
                                                                                                                                                                                (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                        )

                                                                                                                                                                )
                                                                                                                                                        }

                                                                                                                                                    </td>
                                                                                                                                                )
                                                                                                                                                :
                                                                                                                                                ("")
                                                                                                                                        }
                                                                                                                                    </>
                                                                                                                                )

                                                                                                                        }
                                                                                                                    </>
                                                                                                                )
                                                                                                        }
                                                                                                    </>
                                                                                                )
                                                                                        }
                                                                                    </>
                                                                                )
                                                                        }



                                                                        {
                                                                            this.props.location.state.examDetails?.exam_type == 2 ?
                                                                                (
                                                                                    <>
                                                                                        {

                                                                                            item.id == 1 ?
                                                                                                (
                                                                                                    <td>
                                                                                                        {this.state.integerQuestionsBotanySelected.length}
                                                                                                        {
                                                                                                            this.state.jee_pattern_type == 0 ?
                                                                                                                (
                                                                                                                    this.state.integerQuestionsBotanySelected.length > 4 ?
                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")

                                                                                                                )
                                                                                                                :
                                                                                                                (
                                                                                                                    this.state.integerQuestionsBotanySelected.length > 9 ?
                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                )
                                                                                                        }
                                                                                                    </td>
                                                                                                )
                                                                                                :
                                                                                                (
                                                                                                    <>
                                                                                                        {
                                                                                                            item.id == 5 ?
                                                                                                                (
                                                                                                                    <td>
                                                                                                                        {this.state.integerQuestionsZoologySelected.length}
                                                                                                                        {
                                                                                                                            this.state.jee_pattern_type == 0 ?
                                                                                                                                (
                                                                                                                                    this.state.integerQuestionsZoologySelected.length > 4 ?
                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")

                                                                                                                                )
                                                                                                                                :
                                                                                                                                (
                                                                                                                                    this.state.integerQuestionsZoologySelected.length > 9 ?
                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                )
                                                                                                                        }
                                                                                                                    </td>
                                                                                                                )
                                                                                                                :
                                                                                                                (
                                                                                                                    <>
                                                                                                                        {
                                                                                                                            item.id == 2 ?
                                                                                                                                (
                                                                                                                                    <td>
                                                                                                                                        {this.state.integerQuestionsPhysicsSelected.length}
                                                                                                                                        {
                                                                                                                                            this.state.jee_pattern_type == 0 ?
                                                                                                                                                (
                                                                                                                                                    this.state.integerQuestionsPhysicsSelected.length > 4 ?
                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")

                                                                                                                                                )
                                                                                                                                                :
                                                                                                                                                (
                                                                                                                                                    this.state.integerQuestionsPhysicsSelected.length > 9 ?
                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                )
                                                                                                                                        }
                                                                                                                                    </td>
                                                                                                                                )
                                                                                                                                :
                                                                                                                                (
                                                                                                                                    <>
                                                                                                                                        {
                                                                                                                                            item.id == 4 ?
                                                                                                                                                (
                                                                                                                                                    <td>
                                                                                                                                                        {this.state.integerQuestionsMathsSelected.length}
                                                                                                                                                        {
                                                                                                                                                            this.state.jee_pattern_type == 0 ?
                                                                                                                                                                (
                                                                                                                                                                    this.state.integerQuestionsMathsSelected.length > 4 ?
                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")

                                                                                                                                                                )
                                                                                                                                                                :
                                                                                                                                                                (
                                                                                                                                                                    this.state.integerQuestionsMathsSelected.length > 9 ?
                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                )
                                                                                                                                                        }
                                                                                                                                                    </td>
                                                                                                                                                )
                                                                                                                                                :
                                                                                                                                                (
                                                                                                                                                    <>
                                                                                                                                                        {
                                                                                                                                                            item.id == 3 ?
                                                                                                                                                                (
                                                                                                                                                                    <td>
                                                                                                                                                                        {this.state.integerQuestionsChemistrySelected.length}
                                                                                                                                                                        {
                                                                                                                                                                            this.state.jee_pattern_type == 0 ?
                                                                                                                                                                                (
                                                                                                                                                                                    this.state.integerQuestionsChemistrySelected.length > 4 ?
                                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")

                                                                                                                                                                                )
                                                                                                                                                                                :
                                                                                                                                                                                (
                                                                                                                                                                                    this.state.integerQuestionsChemistrySelected.length > 9 ?
                                                                                                                                                                                        (<span className="red_color ml-3">(Maximum Questions Reached)</span>) : ("")
                                                                                                                                                                                )
                                                                                                                                                                        }
                                                                                                                                                                    </td>
                                                                                                                                                                )
                                                                                                                                                                :
                                                                                                                                                                ("")
                                                                                                                                                        }
                                                                                                                                                    </>
                                                                                                                                                )

                                                                                                                                        }
                                                                                                                                    </>
                                                                                                                                )
                                                                                                                        }
                                                                                                                    </>
                                                                                                                )
                                                                                                        }
                                                                                                    </>
                                                                                                )
                                                                                        }
                                                                                    </>

                                                                                ) : ("")
                                                                        }

                                                                    </tr>
                                                                )
                                                            }

                                                        </tbody>

                                                    </table>
                                                </div>
                                            </>
                                        )
                                        :
                                        (
                                            ""
                                        )
                                }
                                <Row className="align-items-center">
                                    <Col xl={4} lg={4} md={6} sm={12} xs={12} className="my-2 d-flex align-items-center">
                                        <div className="mr-2">Class:</div>
                                        <ButtonGroup aria-label="Basic example">
                                            {this.state.classData_s.map((classmapData) => (<Button onClick={(e) => this.ownedquestionClassFun1(e, classmapData.id)} variant={classmapData.active}>{classmapData.class}</Button>))}

                                            {/* <Button variant="outline-secondary">XII-2</Button> */}
                                        </ButtonGroup>
                                    </Col>


                                </Row>
                                <hr />
                                <Form>
                                    <Row>
                                        <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="slectSubject">
                                            <Form.Label className="font-weight-bold">Subject <span className='errorCls'>{this.state.validateSubject}</span></Form.Label>
                                            <SelectBoxWithDisabledOption
                                                stateData={this.state.qbsearchsubjectvalue}
                                                handleChange={this.selecthandleInputChange}
                                                name="qbsearchsubject"
                                                options={this.state.subjectOptions}
                                                placeholderName={'Subject'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId="SelectChapters">
                                            <Form.Label className="font-weight-bold">Chapter <span className='errorCls'>{this.state.validateChapter}</span></Form.Label>
                                            <SelectBoxWithDisabledOption
                                                stateData={this.state.qbsearchchaptervalue}
                                                handleChange={this.selecthandleInputChange}
                                                name="qbsearchchapter"
                                                options={this.state.getChaptersArr}
                                                placeholderName={'Chapters'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} xl={4} lg={4} md={6} sm={12} controlId="SelectTopics">
                                            <Form.Label className="font-weight-bold">Topic <span className='errorCls'>{this.state.validateTopic}</span></Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Topics are selected.",
                                                    "selectSomeItems": topiclabelledBy
                                                }
                                                }
                                                disableSearch={topicdisableSearch}
                                                hasSelectAll={topicselectall}
                                                options={this.state.getTopicsArr}
                                                value={this.state.qbsearchtopicvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "topic")}
                                                labelledBy={"Topics"}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectType">
                                            <Form.Label className="font-weight-bold">Type of Questions </Form.Label>
                                            <SelectBoxWithDisabledOption
                                                stateData={this.state.typeOfQuestionvalue}
                                                handleChange={this.selecthandleInputChange}
                                                name="typeOfQuestion"
                                                options={this.state.getTypeOfQuestionsArr}
                                                placeholderName={'Type of Questions'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className='errorCls'>{this.state.validateTypeOfQuestion}</span>
                                        </Form.Group>
                                        <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="SelectComplexity">
                                            <Form.Label className="font-weight-bold">Complexity </Form.Label>
                                            <SelectBoxWithDisabledOption
                                                stateData={this.state.complexityvalue}
                                                handleChange={this.selecthandleInputChange}
                                                name="complexity"
                                                options={this.state.getComplexityValueArr}
                                                placeholderName={'Complexity'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className='errorCls'>{this.state.validateComplexity}</span>
                                        </Form.Group>
                                        <Form.Group as={Col} xl={6} lg={6} md={6} sm={12} >
                                            <Button type="button" className="btn btn-light-blue float-right mt-2rem" onClick={(e) => this.onScrollgetQuestionById()}>Get Questions</Button>
                                        </Form.Group>
                                    </Row>
                                </Form>
                                {
                                    this.state.getQuestionBankQuestions == "" ?
                                        (
                                            <Row>
                                                <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center" : "hideSpinnerCls text-center"}>
                                                    <div class="spinner-border text-primary text-center loading-img-center"></div>
                                                </Col>
                                            </Row>
                                        )
                                        :
                                        ("")
                                }

                                {
                                    latestData.length > 0 ?
                                        (
                                            <>
                                                {/*<Row>
                                                <Col sm={12}>
                                                    <Form.Group as={Col} xl={3} lg={3} md={6} sm={12} controlId="quentionSearch" className='float-right'>
                                                        <Form.Control
                                                            type="text"
                                                            name="quesionsearch"
                                                            value={this.state.quesionsearch}
                                                            onChange={this.quentionSearchhandleChange}
                                                            placeholder="Question Search"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>*/}
                                                <div className='mt-1'>
                                                    <CardLessDataTable
                                                        parentData={this.questionsTable(latestData)}
                                                        particlecolumns={this.colFunction}
                                                        searchBar={false}
                                                    />
                                                </div>



                                            </>
                                        )
                                        :
                                        (
                                            this.state.showQuestionsNotAvailable == "no" ?
                                                (<h6 className='text-center mt-2 mb-2'>Questions Not Available....</h6>)
                                                :
                                                ("")


                                        )
                                }




                            </Card>


                        </>


                    </Col>
                    <Col sm={4} className='mt-3'>
                        <div className='aside_bar_edit'>
                            <Row>
                                <Col sm={12}>
                                    <Card as={Card.Body} className='block_white'>
                                        <EditQuestionSelectedDetails
                                            stateData={this.state}
                                            globals={this.props.globals}
                                            showQuestionGenerateModal={this.showQuestionGenerateModal}
                                            pselecthandleInputChange={this.selecthandleInputChange}
                                            ponScrollgetQuestionById={this.onScrollgetQuestionById}
                                            handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                                        />
                                    </Card>
                                </Col>
                            </Row>

                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <EditExamMadeEasyModal
                            stateData={this.state}
                            parentpdatefunction={this.datefunction}
                            parentpdatefunctionend={this.datefunctionend}
                            ParenthandleFormSubmit={this.handleFormSubmit}
                            show={this.state.modalShow}
                            onHide={() => this.setState({ modalShow: false, submitError1: "" })}
                            globals={this.props.globals}
                            phandleInputChange={this.handleInputChange}
                            pselecthandleInputChange={this.selecthandleInputChange}
                            handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                        />
                    </Col>
                </Row>

            </Container>
        )
    }
}


export default withRouter(withApollo(
    compose(
        graphql(GROUPEXAMMADEEASY_PAPER, {
            name: "createExamMadeEasyPaper"
        }),
        graphql(GROUPEXAMMADEEASY_DRAFT_PAPER, {
            name: "examMadeEasyDraftPapers"
        }),
    )
        (EditExamMadeEasy)));


